//TODO: to be customized
export class APIError extends Error{
    constructor(message: string) {
        super(message);
    }
}